import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        container: {
            marginBottom: theme.spacing(2),
        },
    }
})
